import * as Sentry from "@sentry/react"

// DSN приходит из layout-меты (ENV SENTRY_FRONTEND_DSN на сервере).
// Без меты — no-op: локальная разработка и текущий прод не затронуты.
export function initSentry(): void {
  const dsn = document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')?.content
  if (!dsn) return

  const environment = document.querySelector<HTMLMetaElement>('meta[name="sentry-environment"]')?.content
  const tracesRaw = document.querySelector<HTMLMetaElement>('meta[name="sentry-traces-sample-rate"]')?.content
  const tracesSampleRate = tracesRaw != null && tracesRaw !== "" ? Number(tracesRaw) : 0.01

  Sentry.init({
    dsn,
    environment: environment || "production",
    sendDefaultPii: false,
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.01,
  })
}
